export class PromptCommandCategory {
  id: string;
  name: string;
  icon?: string;

  constructor({ id, name, icon }: { id: string; name: string; icon?: string }) {
    this.id = id;
    this.name = name;
    this.icon = icon;
  }
}
